<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_vii"></a>Contents</h2>
<p class="toc-entrya"><a href="#/xhtml/frontmatter01#frontmatter01">Acknowledgments</a></p>
<p class="toc-entrya"><a href="#/xhtml/frontmatter02#frontmatter02">Introduction</a></p>
<p class="toc-entry1"><span href="#/xhtml/part01#part01" title="Link target outside of Sample"><strong>Part I. Toussaint Louverture</strong></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter01#chapter01" title="Link target outside of Sample">1 Toussaint Louverture and the Family of Saint-Domingue</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter02#chapter02" title="Link target outside of Sample">2 Under the Stick of Maître Toussaint</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter03#chapter03" title="Link target outside of Sample">3 “Free and French”: La Constitution de la colonie française de Saint-Domingue</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter04#chapter04" title="Link target outside of Sample">4 Toussaint Louverture at a Crossroads: The <em>Mémoire</em> of the “First Soldier of the Republic of Saint Domingue”</span></p>
<p class="toc-entry1"><span href="#/xhtml/part02#part02" title="Link target outside of Sample"><strong>Part II. Aimé Césaire</strong></span></p>
<p class="toc-entry"><span href="#/xhtml/chapter05#chapter05" title="Link target outside of Sample">5 Césaire Reads Toussaint: The Haitian Revolution and the Problem of Departmentalization</span></p>
<p class="toc-entry"><span href="#/xhtml/chapter06#chapter06" title="Link target outside of Sample">6 Haitian Building: <em>La tragédie du roi Christophe</em></span></p>
<p class="toc-entrya"><span href="#/xhtml/backmatter01#backmatter01" title="Link target outside of Sample">Conclusion: Artisans of Free and French</span></p>
<p class="toc-entrya"><span href="#/xhtml/backmatter02#backmatter02" title="Link target outside of Sample">Notes</span></p>
<p class="toc-entrya1"><span href="#/xhtml/backmatter03#backmatter03" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-entrya1"><span href="#/xhtml/backmatter04#backmatter04" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8ac0c6aa